/* eslint-disable no-use-before-define */
import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import UserItem from './UserItem';
import UserService from '../../../Services/userService';
import stringHelper from '../../../Helpers/stringHelper';

class EditRelatedUserWindowDescription extends React.Component {
  static titleForCreate = 'Add New Related User';
  static titleForEdit = 'Edit User';
  static ComponentName = 'User';
  static itemType = UserItem;
  static serviceFunction = (edited) =>
    edited.IsNewUser ? UserService.CreateRelatedUser(edited) : UserService.SaveRelatedUser(edited);

  static onNameChange(editedItem) {
    const firstName = stringHelper.nameCleaning(editedItem.FirstName.toLowerCase().substring(0, 1));
    const lastName = stringHelper.nameCleaning(editedItem.LastName.toLowerCase());
    editedItem.UserName = firstName + lastName;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SelectedCaspianRoles',
          label: 'Caspian Roles',
          className: 'col-12',
          type: InputTypesEnum.CaspianRolesMultiCheck,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default EditRelatedUserWindowDescription;
